/**
 * Utility functions for formatting data in the application
 */

/**
 * Format file size from bytes to human-readable format
 * @param bytes - File size in bytes
 * @returns Formatted string (e.g., "1.5 MB", "500 KB")
 */
export const formatFileSize = (bytes: number): string => {
  if (!bytes || bytes === 0) return "Unknown size";
  if (bytes < 1024) return `${bytes} B`;

  const k = 1024;
  const sizes = ["Bytes", "KB", "MB", "GB"];
  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(2))} ${sizes[i]}`;
};

/**
 * Format date string to localized format
 * @param dateString - Date string (supports underscore or dash separators)
 * @returns Formatted date (MM/DD/YYYY) or original string if parsing fails
 */
export const formatDate = (dateString: string): string => {
  try {
    const date = new Date(dateString.replace(/_/g, "-"));
    return date.toLocaleDateString("en-US", {
      month: "2-digit",
      day: "2-digit",
      year: "numeric",
    });
  } catch {
    return dateString;
  }
};

export const formatChildName = (childName: string): string => {
  return childName.replace(/[^a-zA-Z0-9]/g, "_").replace(/_+/g, "_");
};
